/**
 * 基础枚举类
 */
export class BaseEnumItem {
  constructor(key, value) {
    this.key = key;
    this.value = value;
  }
}

export class BaseEnum {
  constructor() {
    this.items = new Map();
  }

  set(key, item) {
    this.items.set(key, item);
  }

  get(key) {
    return this.items.get(key);
  }

  has(key) {
    return this.items.has(key);
  }

  delete(key) {
    return this.items.delete(key);
  }

  clear() {
    this.items.clear();
  }

  size() {
    return this.items.size;
  }

  // 获取所有项
  getItems() {
    return Array.from(this.items.values());
  }

  // 获取所有键
  getKeys() {
    return Array.from(this.items.keys());
  }

  // 获取所有值
  getValues() {
    return Array.from(this.items.values()).map(item => item.value);
  }

  // 根据值查找键
  getKeyByValue(value) {
    const item = this.getItems().find(item => item.value === value);
    return item ? item.key : undefined;
  }

  // 根据键查找值
  getValueByKey(key) {
    const item = this.get(key);
    return item ? item.value : undefined;
  }
}